/* eslint-disable import/no-unresolved */
import { Thermostat, WaterDropOutlined, ElectricBolt } from '@mui/icons-material';
import Iconify from 'src/components/iconify/Iconify';
import { Box } from '@mui/material';

const SENSOR_ICONS = {
  tempI: (props) => <Thermostat {...props} fontSize="" />,
  tempP1: (props) => <Iconify {...props} icon="mdi:thermometer-probe" />,
  humidI: (props) => <WaterDropOutlined {...props} fontSize="" />,
  dfrO2: ({ width = 24, sx, ...props }) => (
    <Box
      component="svg"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      sx={{ width, height: width, verticalAlign: '-0.125em', flexShrink: 0, ...sx }}
    >
      <circle cx="6.4" cy="5.1" r="2.2" />
      <circle cx="11.3" cy="2.7" r="1.15" />
      <circle cx="8.7" cy="14" r="5.2" />
      <text x="13.9" y="21.6" fontSize="12" fontWeight="800" fill="currentColor" stroke="none" fontFamily="ui-sans-serif, system-ui, Arial, sans-serif">2</text>
    </Box>
  ),
  pressure: (props) => <Iconify {...props} icon="ix:gauge" />,
  lid: (props) => <Iconify {...props} icon="system-uicons:box-open" />,
  imu: (props) => <ElectricBolt {...props} fontSize="" />,
  als: (props) => <Iconify {...props} icon="lets-icons:sun-light" />,
  carContainer: (props) => <Iconify {...props} icon="ph:shipping-container-duotone" />,
  carSeat: (props) => <Iconify {...props} icon="mdi:steering" />,
};

export default SENSOR_ICONS;
